import type { MeVo } from "@zhihaoscm/entity";
import request from "../index";

export const getUserInfo = async () => {
  try {
    const res = await request.service.get<MeVo>("/custom/login/me");
    return res.data;
  } catch {
    void 0;
  }
};